<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lbn6rs/tc-custom/9781452103273.jpg?1705238413001" alt="This image is the cover for the book Horrorscopes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Horrorscopes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover what dark fate awaits you based on your birthday in this spooky take on horoscopes, featuring dark days, unlucky numbers, and evil omens.</b></p> This book is full of eerie predictions and ominous fortunes that add a sinister twist to the typical horoscope. Those who enjoy the dark side can look up their birthday to discover the terrible fate that awaits them—from attack by hungry zombies to transformation into an ogre. With useful information including dark days, unlucky numbers, and evil omens, this chilling guide is sure to have readers looking under their beds and over their shoulders all year long. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucien Edwards, Eugene Smith
      </h2>
      
      <p class="authorDescription body article">Lucien Edwards is a San Francisco-based freelance writer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16e1c4bd